import { render, staticRenderFns } from "./modalDetalleCupon.vue?vue&type=template&id=2a66f2f2"
import script from "./modalDetalleCupon.vue?vue&type=script&lang=js"
export * from "./modalDetalleCupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports